import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { ComponentDependencyJunctionService } from '@app/core/services/component-dependency-junction.service';
import { MixedObject } from '@core/interfaces/mixed-object';
import { GlobalService, MediaQuery } from '@core/services/common/global.service';
import { SubSink } from '@core/utils/subsink';
import { FormFieldBase } from '@modules/creator/components/forms/form-field/form-field-base';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';
import { mergeAllStyles } from '@shared/helpers/block-helpers';
import { camelCase } from 'lodash';

@Component({
  selector: '[form-field-search]',
  styleUrls: ['./form-field-search.scss'],
  template: `
    <div class="searchClass">
      <div [formGroup]="formGroup">
        <mat-form-field appearance="outline" [class]="item.uId" [ngStyle]="blockStyles. basic">
          <mat-label>{{ item.content }}</mat-label>
          <input matInput [type]="inputType"
                 [formControlName]="formName"
                 (keyup)="onKey($event)"
                 [attr.aria-label]="item.content || null"
                 [required]="false"
                 [tabIndex]="item.tabindex"
                 autocomplete="auto"
                 (ngModelChange)="dataChanged($event)">
        </mat-form-field>

      </div>
    </div>

  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FormFieldSearchComponent extends FormFieldBase implements AfterViewInit {
  private subSink = new SubSink();
  blockStyles: MixedObject = {};

  constructor(
    fs: FormService,
    private _element: ElementRef,
    private junction: ComponentDependencyJunctionService,
    private globalService: GlobalService,
  ) {
    super(fs);
  }

  ngOnInit() {
    super.ngOnInit();
    this.subSink.sink = this.globalService.mediaQuery.subscribe((mediaQuery) => {
      this.generateBlockStyles(mediaQuery);
    });
    this.generateBlockStyles(this.globalService.mediaQuery.value);
  }

  private generateBlockStyles(mediaQuery: MediaQuery): void {
    const querySnakeCase = camelCase(mediaQuery.query);
    this.blockStyles = mergeAllStyles(this.item.styles, querySnakeCase);
  }

  async getHeight(): Promise<void> {
    const height = await this.getElementHeight();
    let newHeight = height;
    // if(height >= 40 ){
    const multiplier = 1 + (height / 100);
    newHeight = height * multiplier;
    // }
    document.documentElement.style.setProperty('--my-variable', `-${Math.round(newHeight)}px`);
  }

  getElementHeight(attempt = 0): Promise<number> {
    return new Promise((resolve) => {
      const height = +window.getComputedStyle(this._element.nativeElement).height.replace('px', '');
      if (isNaN(height) || height === 0) {
        if (attempt > 5) {
          resolve(0);
          return;
        }
        setTimeout(() => {
          resolve(this.getElementHeight(attempt + 1));
        }, 100);
        return;
      }
      resolve(height);
    });
  }

  ngAfterViewInit(): void {
    const [input] = this._element.nativeElement
      .querySelectorAll(`input.${this.item.uId}`);
    this.junction.setElement(input);
    this.getHeight();
  }
}
